import React from "react";
import { Card, Button, Row, Col } from 'react-bootstrap';
import Plans from "../component/plan/Plans";
import SearchSection from "../component/search/SearchSection";
import AboutUs from "../component/aboutUs/AboutUs";
import { Helmet } from "react-helmet";
import WelcomeModal from "../component/common/WelcomeModal";
import welcomeimage from '../assets/welcome-image.webp';
import playstore from '../assets/googleplay.webp';
import appstore from '../assets/appstore.webp';
import tireRepair from '../assets/tire-repair.svg';
import towingService from '../assets/towing-service.svg';


const HomePage = () => {

    return (
        <div className="main_content">
            <Helmet>
                <link rel="canonical" href="/" />
                <link rel="preload" href="https://fonts.gstatic.com/s/mulish/v17/1Ptvg83HX_SGhgqk3wot.woff2" as="font" type="font/woff2"
                    crossorigin="anonymous" />
                <link rel="preload"
                    href="https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap"
                    as="style" type="font/woff2" crossorigin="anonymous" />
                <link rel="preload" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" as="style" />

                <title>Emergency Roadside Truck & Trailer Repair – Open 24/7</title>
                <meta name="keywords" content="trailer repair shops,truck and trailer repair,truck repair near me,truck repair shops near me,semi trailer repair shop" />
                <meta name="description" content="Emergency? Our certified Truck & Trailer Repair pros are just a call away—day or night. Fast mobile response keeps you moving. Call now for trusted help!" />
                <meta property="og:title" content="Emergency Roadside Truck & Trailer Repair – Open 24/7" />
                <meta property="og:description" content="Emergency? Our certified Truck & Trailer Repair pros are just a call away—day or night. Fast mobile response keeps you moving. Call now for trusted help!" />
                <link rel="preload" as="image" href={welcomeimage} />
                <link rel="preload" as="image" href={appstore} />
                <link rel="preload" as="image" href={playstore} />

            </Helmet>

            {/*<WelcomeModal />*/}
            <SearchSection />

            {/*Featured Plan Section Start*/}

            {/*<section className="featured_slider">
             <div className="container">
                <div className="row">
                <div class="section-title col-md-12 mb-5 pb-3">
                <h2>The #1 Choice for Professionals</h2>
                <p>Join over 150,000 businesses that trust us to deliver top-tier results.</p>
                </div>
                </div>

                <div className="row">
                <div className="slider-container">
                <div className="slider-track">
                <div className="featured_plan_card">
                Featured Plan HTML Code Write Here.....
                </div>
                </div>
                </div>
                </div>
             </div>
            </section>*/}

            {/*Featured Plan Section End*/}

            <AboutUs />
            <Plans />
        </div>
    );
};

export default HomePage;